import { Component, effect, ElementRef, EventEmitter, HostListener, inject, Input, LOCALE_ID, OnInit, Output } from '@angular/core';
import { Params, Router } from '@angular/router';
import { NavItem } from 'src/app/interfaces/nav-item';
import { Notification } from 'src/app/interfaces/notifications';
import { NavService } from 'src/app/services/nav.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { TabService } from 'src/app/services/tab.service';

@Component({
    selector: 'notifications-card',
    templateUrl: './notifications-card.component.html',
    styleUrls: ['./notifications-card.component.scss'],
    standalone: false,
    providers: [
    { provide: LOCALE_ID, useValue: 'en-US' } // ou outro locale
  ]
})
export class NotificationsCardComponent implements OnInit {

 
  private readonly store = inject(NotificationsService);
 
  open = false;
  notificationsWorker: Worker;
  readonly items = this.store.items;
  readonly unreadCount = this.store.unreadCount;
  showAll = false;
  visibleItems: Notification[] = [];
  readonly syncVisibleItems = effect(() => {
    this.updateVisibleItems();
  });

  constructor(private _router: Router, private nav:NavService, private tab:TabService) { 
    
  }

  ngOnDestroy(): void {
   
    if (this.notificationsWorker) {
      this.notificationsWorker.postMessage({ command: 'stop' });
      this.notificationsWorker.terminate();
    }
    
  }


  trackById(index: number, n: Notification) {
    return n.IDALERT;
  }

  updateVisibleItems() {
    const all = this.items();
    this.visibleItems = this.showAll ? all : all.slice(0, 3);
  }

  toggleSeeAll() {
    this.showAll = !this.showAll;
    this.updateVisibleItems();
  }

  ngOnInit(): void {

      if (typeof Worker !== 'undefined') {
        this.notificationsWorker = new Worker(new URL('../notifications.worker', import.meta.url), { type: 'module' });
      }
      
      if (this.notificationsWorker) {
        this.notificationsWorker.onmessage = ({ data }) => {
          if (data.command === 'fetch') {
            this.store.fetchNotifications();
          }
        };

        // Iniciar polling no worker (a cada 10 segundos)
        this.notificationsWorker.postMessage({ command: 'start', interval: 30000 });
      } else {
        // Fallback se Web Workers não forem suportados
        setInterval(() => this.store.fetchNotifications(), 30000);
      }
  }

  navigate(event, item: Notification) {
    event.stopPropagation();
    this.store.markAsRead(item.IDALERT);
    if (item.ROUTE) {
      let navItem:NavItem = {
                  displayName:'dummy',
                  expanded:false,
                  hidden:false,
                  id:'0',
                  nuMenu:'1',
                  route:item.ROUTE,
                  visible:false,
                  level:0
        }

        let state:Params = null;
        if (item.STATE) {
          let j = JSON.parse(item.STATE);
          if (typeof j === 'object') {
            state = j;
          }
        }
        
        this.nav.selectItem2(navItem,  this._router, this.tab, item.ROUTE,this.store.userInformation.iduser,state) 
        this.open = false;
      }
  }

   onItemClick(n: Notification): void {
        this.store.markAsRead(n.IDALERT);

        if (n.ROUTE) { 
          let navItem:NavItem = {
                  displayName:'dummy',
                  expanded:false,
                  hidden:false,
                  id:'0',
                  nuMenu:'1',
                  route:n.ROUTE,
                  visible:false,
                  level:0
              }
          this.nav.selectItem2(navItem,  this._router, this.tab, n.ROUTE,this.store.userInformation.iduser,{nodata: false, condition: 'codecompany=105' }) 
          this.open = false;
         }
    }
 
    markAllAsRead(): void {
        this.store.markAllAsRead();
    }
 
    iconFor(type?: Notification['STATUSALERT']): string {
        switch (type) {
            case 'sucesso': return 'check-circle';
            case 'atencao': return 'warning';
            case 'falha':   return 'close-circle';
            default:        return 'info-circle';
        }
    }


      
    
}

